"use strict";

var _classCallCheck = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@eth-sdk/utils");

var Net = /*#__PURE__*/function () {
  function Net(query) {
    _classCallCheck(this, Net);

    this.query = query; //
  }

  _createClass(Net, [{
    key: "version",
    get: function get() {
      return this.query.send(Net.Methods.Version).then(function (result) {
        return utils_1.toNumber(result);
      });
    }
  }]);

  return Net;
}();

exports.Net = Net;

(function (Net) {
  var Methods;

  (function (Methods) {
    Methods["Version"] = "net_version";
  })(Methods = Net.Methods || (Net.Methods = {}));
})(Net = exports.Net || (exports.Net = {}));